export default __webpack_public_path__ + "static/media/serve4.6cca6734.png";